<p-dialog
  header="Customer Service Fee Details"
  [(visible)]="displayDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '600px' }"
>
  <div class="ui-g ui-fluid" *ngIf="serviceFeeType">
    <div class="ui-g-12">
      <div class="ui-g-4">
        <label for="name">Name</label>
      </div>
      <div class="ui-g-8">
        <input pInputText type="string" id="name" [(ngModel)]="serviceFeeType.name" />
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-4">
        <label for="name" title="Will be visible on Transaction Line"
          >Display Name (As Visible on Transaction Line)</label
        >
      </div>
      <div class="ui-g-8">
        <input pInputText type="string" id="displayName" [(ngModel)]="serviceFeeType.displayName" />
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-4">
        <label for="defaultValue">Default Value</label>
      </div>
      <div class="ui-g-8">
        <input
          pInputText
          type="number"
          id="defaultValue"
          [(ngModel)]="serviceFeeType.defaultValue"
        />
      </div>
    </div>
  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <button
        type="button"
        pButton
        icon="fa fa-close"
        (click)="displayDialog = false"
        label="Cancel"
        class="ui-btn-secondary"
      ></button>
      <button
        *ngIf="!newServiceFeeType"
        type="button"
        pButton
        icon="fa fa-close"
        (click)="delete()"
        label="Delete"
        class="red-btn"
      ></button>
      <button
        type="button"
        pButton
        icon="fa fa-check"
        (click)="save()"
        label="Save"
        class="green-btn"
      ></button>
    </div>
  </p-footer>
</p-dialog>

<p-panel header="Service Fee Types">
  <p-table
    [columns]="cols"
    [value]="serviceFeeTypes && serviceFeeTypes.items"
    selectionMode="single"
    [(selection)]="selectedServiceFeeType"
    (onRowSelect)="onRowSelect($event)"
    [paginator]="true"
    [rows]="15"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
          {{ col.header }}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr [pSelectableRow]="rowData">
        <td *ngFor="let col of columns">
          {{ rowData[col.field] }}
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div style="text-align: right" class="pt-2">
    <button
      [disabled]="isReadonly"
      type="button"
      pButton
      icon="fa fa-plus"
      (click)="showDialogToAdd()"
      label="Add"
    ></button>
  </div>
</p-panel>
